/**
 * Memanggil window.print() setelah React selesai commit dan browser sempat menggambar DOM
 * (termasuk barcode yang digambar JsBarcode di effect).
 *
 * Jangan panggil window.print() langsung di dalam useEffect: print() memblokir thread JS
 * selama dialog cetak terbuka. Di React 18 update state yang masih tertunda bisa diproses
 * ketika React masih di fase commit, dan preview cetak menangkap DOM sebelum data ter-render
 * ("Loading"). Dipakai sebagai nilai return effect supaya timer dibatalkan jika komponen
 * unmount atau data berubah sebelum sempat dicetak.
 *
 * @param {number} [delayMs=300]
 * @returns {() => void} fungsi cleanup untuk useEffect
 */
export function printAfterRender(delayMs = 300) {
  const timer = setTimeout(() => {
    window.print();
  }, delayMs);
  return () => clearTimeout(timer);
}

export default printAfterRender;
